import axiosInstance from "../axiosInterceptor";

export async function getCategories() {
    const response = await axiosInstance.get(`admin/category/getAllCategory`);
    const data = response?.data;
    return data;
}
